export default {
    'word': {
        'confirm': 'Confirm',
        'close': 'Close',
        'clear': 'Clear',
        'operation': '🔧',
        'schedule_time': 'Schedule',
        'is_unicode': 'IsUnicode',
        'campaign_name': 'Name',
        'campaign_id': 'CampaignID',
        'cancel': 'Cancel',
        'back': 'Back',
        'edit': 'Edit',
        'update': 'Update',
        'report': 'Report',
        'save': 'Save',
        'create': 'Create',
        'logout': 'Logout',
        'me_center': 'Profile',
        'resolve': 'Resolve',
        'reject': 'Reject',
        'query': 'Query',
        'reset': 'Reset',
        'notification': 'Notification',
        'change_password': 'Change password',
        'change_timezone': 'Change default timezone',
        'password_old': 'Old password',
        'password_new': 'New password',
        'timezone': 'Timezone',
        'toggle_sidebar': 'Toggle SideBar',
        'settings': 'Settings',
        'ct_time': 'CreatedAt',
        'remark': 'Remark',
        'field_empty': 'Field empty',
        'field_invalid': 'Field invalid',
        'id': 'ID',
        'name': 'Name',
        'content': 'Content',
        'status': 'Status',
        'review': 'Review',
        'country': 'Country',
        'amount': 'Amount',
        'cp': 'CP',
        'message_id': 'MessageID',
        'mid': "MID",
        'sp_id': 'SpID',
        'cp_id': 'CpID',
        'msisdn': 'MSISDN',
        'cp_data': 'CpData',
        'up_time': 'UpdatedAt',
        'search': 'Search',
        'sp_app_id': 'SpApp',
        'cp_app_id': 'CpApp',
        'sp_message_id': 'SpMsgID',
        'account_id': 'AccountID',
        'account_token': 'Token',
        'app_token': 'AppToken',
        'status_code': 'Code',
        'status_msg': 'StatusMsg',
        'sync_status': 'SyncStatus',
        'sync_time': 'SyncAt',
        'date': 'Date',
        'count': 'Count',
        'refresh': 'Refresh',
        'sp_name': 'SpName',
        'cp_name': 'CpName',
        'count_accepted': 'Accepted',
        'count_deleted': 'Deleted',
        'count_delivered': 'Delivered',
        'count_enroute': 'EnRoute',
        'count_expired': 'Expired',
        'count_invalid': 'Invalid',
        'count_rejected': 'Rejected',
        'count_scheduled': 'Scheduled',
        'topup_amount': 'Top up Amount',
        'all_apps': 'All Apps',
        'app_id': 'App ID',
        'app_id_or_sender_id': 'App/Sender',
        'price': 'Price',
        'select_sp': 'SP',
        'bind_cp_app_id': 'CpApp',
        'is_flash': 'IsFlash',
        'address_id': 'ID',
        'address_name': 'GroupName',
        'numbers': 'Numbers',
        'import': 'Import',
        'add': 'Add',
        'select_all': 'Select All',
        'select_inverse': 'Select Reverse',
        'delete': 'Delete',
        'submit': 'Submit',
        'menu_cp': 'CP Management',
        'menu_sp': 'SP Management',
        'menu_trx': 'Report',
        'sender_id': 'Sender',
        'sender_status': 'Status',
        'app_status': 'Status',
        'templates': 'Templates',
        'drop_this_item': 'Drop this item?',
        'page_size': 'PageSize',
        'select_cp': 'CP',
        'app_name': 'AppName',
        'action': 'Action',
        'sender': 'Sender',
        'waiting': 'Waiting',
        'contract_groups': 'Contract Groups',
        'import_async_hint': '1. Only support csv file<br>2. File format is fixed, see demo below<br>3. After upload, file will process asynchronous, please wait',
        'do_upload': 'Upload',
        'do_upload_hint': 'Only support csv file, file size smaller than 10MB',
        'do_upload_choose': 'Choose',
        'demo_import_format': 'File format demo',
        'rate_pack': 'Rate Plan',
        'send': 'Send',
        'send_report': 'Send Report',
        'send_detail': 'Send Transactions',
        'trx_status': {'0': 'Pending', '1': 'Sending', '2': 'Success', '3': 'Fail', '4': 'Closed'},
        'api_type': 'API Type',
        'smpp_port': 'Port',
        'smpp_host': 'Host',
        'smpp_user': 'User',
        'smpp_pass': 'Password',
        'smpp_sender': 'SenderID',
        "link_id": "LinkID",
        "scheduled": "Scheduled",
        "delivered": "Delivered",
        "error": "Error",
        "status_send": "SendStatus",
        "status_deliver": "DeliverStatus",
        "tpl_id": "TplID",
        "dlr_err_code": "DLRErrCode",
        "dlr_err_msg": "DLRErrMsg",
        "dlr_done_time": "DLRDoneTime",
        "dlr_submit_time": "DLRSubmitTime",
        "dlr_time": "DLRTime",
        "app_purpose": "Purpose",
        "cb_url": "CbUrl",
        "cb_method": "Method",
        "cb_ct": "ContentType",
        "online": "ONLINE",
        "offline": "DELETED",
        "is_lock": "Lock",
        "show_message": "Message",
        "message_content": "Content",
        "ips": 'IPs',
        'src_address': 'FromAddress',
        'dest_address': 'ToAddress',
        "dlr_is": "DLR",
        "test": "Test",
        "message": "Message",
        "result": "Result",
        "copy": "Copy",
        "dlr_code": "Code",
        "tz": "Timezone",
        "per_success": "%S",
        "per_fail": "%U",
        "total":"Total",
        "message_export":"EXM",
        "export":"Export",
    },
    'login': {
        'name': 'Name',
        'password': 'Password',
        'login': 'Login',
        'help': 'Help',
        'about': 'About',
        'keep': 'Keep me login',
        'message_need_login': 'Please login',
        'error': {
            'username_empty': 'please enter username',
            'password_empty': 'please enter password',
            'password_simple': 'password must longer than 6 chars',
        }
    },
    'spsite': {
        'menu_cp_app': 'CP Apps',
        'menu_cp_templates': 'CP Templates',
        'menu_cp_pack': 'CP Rate Plan',
        'menu_cp': 'CP',
        "menu_test_trx": "Transaction",
        'cp': {
            'title': 'CP Management',
            'tips_token': 'Token is key parameter when call API',
            'prop_remark': 'Remark',
            'prop_cp': 'CpName',
            'error': {
                'remark_empty': 'remark is empty',
                'cp_name_empty': 'cp name is empty'
            },
            'cp_status': {'1': 'Running', '2': 'Pause'},
        },
        'cpapp': {
            'title': 'CP Apps Management',
            'app_status': {'0': 'Waiting', '1': 'Running', '2': 'Pause', '3': 'Reject'},
            'app_status_type': {'0': '', '1': 'success', '2': 'warning', '3': 'danger'},
            'account_token': 'AccountToken',
            'account_id': 'AccountID',
            'app_id': 'AppID',
            'app_token': 'AppToken',
            'prop_remark': 'Remark',
            'choose_sp': 'Choose SP',
            'cp_app_id': 'Binding To Cp APP',
            'sender_id': 'Bind Sender',
            'select_action': 'Choose Action',
            'error': {
                'field_empty': 'Field empty'
            }
        },
        'cppack': {
            'title': 'Cp Pack Management',
            'amount_tips': 'Amount in $',
            'price_tips': 'Price in $',
        },
        'sp': {
            'title': 'SP Management',
            'tips_token': 'Token is key parameter when call API',
            'prop_remark': 'Remark',
            'prop_sp': 'SpName',
            'error': {
                'remark_empty': 'remark is empty',
                'sp_name_empty': 'sp name is empty'
            },
        },
        'spapp': {
            'title': 'SP Apps Management',
            'app_status': {'1': 'Running', '2': 'Pause'},
            'account_token': 'AccountToken',
            'account_id': 'AccountID',
            'app_id': 'AppID',
            'app_token': 'AppToken',
            'prop_remark': 'Remark',
            'choose_sp': 'Choose SP',
            'cp_app_id': 'Binding To Cp APP',
            'error': {
                'field_empty': 'Field empty'
            }
        },
        'tpl': {
            'title': 'Templates',
            'select_action': 'Review'
        },
        'transaction': {
            'detail': {
                'title': 'Transaction Detail'
            },
            'summary': {
                'title': 'Transaction Summary'
            }
        }
    },
    'cpsite': {
        'app': {
            'title': 'App Management',
            'app_name': 'Name',
            'app_id': 'App ID',
            'app_token': 'App Token',
            'app_status': 'Status',
            'app_purpose': 'Purpose',
            'app_status_str': {'0': 'Waiting', '1': 'Living', '2': 'Paused', '3': 'Rejected'},
            'app_status_type': {0: '', '1': 'success', '2': 'warning', '3': 'danger'},
            'app_status_str_tooltip': 'Waiting/Living/Paused/Rejected',
            'error': {
                'field_empty': 'Field is empty'
            }
        },
        'tpl': {
            'title': 'Templates',
            'message': {
                'tpl_empty': 'No template'
            },
            'tpl_status_str': {'1': 'Waiting', '2': 'Live', '3': 'Rejected'},
            'prop_tpl_name': 'Name',
            'prop_tpl_content': 'Content'
        },
        'pack': {
            'title': 'Pack'
        },
        'balance': {
            'title': 'Balance & TopUp',
            'balance': 'Balance',
            'topup': 'TopUp',
        },
        'trx': {
            'title': 'Transaction Detail'
        },
        'send': {
            'title': 'Send',
            'choose_template': 'Choose template',
            'from_address': 'Address Book',
            'from_address_forbidden': 'Template with variable do not support this option',
            'from_file': 'Import',
            'from_input': 'Input',
            'submit_success': 'Submit Successfully',
            'submit_success_sub': 'Report will shown in report area',
            'submit_success_to_report': 'Check Report',
            'submit_success_to_report_again': 'Send another one'
        }
    },
};